import { render, staticRenderFns } from "./TvosJpy.vue?vue&type=template&id=4dab95a4&"
import script from "./TvosJpy.vue?vue&type=script&lang=js&"
export * from "./TvosJpy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports